import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d1b7346e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "issue-notes-info-block" }

import { ref, watch, toRefs } from 'vue'	
  import { getbatch, getissed } from '@/service/main/invoices/documentsManagement';
  import { getManualOutedit} from '@/service/main/invoices/documentsManagement';
  import { ElMessage, ElMessageBox,ElLoading } from 'element-plus';
  import { getSendShipOrderPage,CreateJiaJiJianList } from '@/service/main/supplier/index'
//   import { getInspectionMethod } from '../switchCase'
  import Pagination from "@/components/Pagination/index.vue";
  
export default /*#__PURE__*/_defineComponent({
  props: {
      visible:{
          type:Boolean,
          default:false
      },
      info:{
          type:Object,
          default:()=>{
              return []
          }
      },
      infoType:{
          type:String,
          default:''
      }
  },
  emits: ['update:visible','loadData','callback'],
  setup(__props, { emit: emits }) {

const props = __props

  
  
  
  const { visible, info ,infoType} = toRefs(props)
  
  const innerVisible = ref(false)
  const detailData:any = ref([])
  const tableDataItems = ref<number>(0)
  
  watch(
      visible,
      function(newVal){
          if (innerVisible.value!==newVal) {
              innerVisible.value = newVal            
              init()            
          }
      },
      {immediate:true}
  )
  watch(innerVisible,function(newVal){
      if (visible.value!==newVal) {
          emits('update:visible',newVal)
      }
  })
  
  
  const Params = ref({
      page: 1,
      pageSize: 5,
    });
    // 查询新建送货单列表数据接口参数定义
  const creating = ref({
    detailId:''
  })
  const detailsReset = () => {
      creating.value.detailId = ""
  }
  // 获取系统生成的送货单号,获取送货单详情
  const init = () => {
      if(info.value.length!=0){
        detailData.value = info.value || []
          //getDetails()
      }    
  }
  
  // 获取新建送货单列表数据
  const getDetails = () => {
      detailsReset()
      creating.value.detailId = info.value.detailId
      getOrderDetailInfo()
  }
  
  const getOrderDetailInfo = () => {
    detailData.value = []
	getManualOutedit({id:info.value.detailId,PageNo:1,PageSize:9999}).then((res) => {
        detailData.value = res.data.rows || []
	})
}
  
return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, {
      class: "full-table",
      shadow: "hover",
      style: {"margin-top":"8px"},
      modelValue: innerVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((innerVisible).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: detailData.value,
          style: {"width":"100%"},
          "tooltip-effect": "light",
          "row-key": "id",
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "序号",
              align: "center",
              width: "60",
              type: "index"
            }),
            _createVNode(_component_el_table_column, {
              label: "项目编号",
              prop: "projectCode",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "品名",
              prop: "name",
              align: "center",
              width: ""
            }),
            _createVNode(_component_el_table_column, {
              label: "品号",
              prop: "code",
              align: "center",
              width: ""
            }),
            _createVNode(_component_el_table_column, {
              label: "规格型号",
              prop: "specificationModel",
              align: "center",
              width: "250"
            }),
            _createVNode(_component_el_table_column, {
              label: "单位",
              prop: "unit",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "转入库位",
              prop: "transferredILocation",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "单据数",
              prop: "orderQuantity",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "下发数",
              prop: "actualQuantity",
              align: "center"
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})